import { BRAND } from "../lib/brand";

export const SITE_SETTINGS = {
  brand: BRAND,
  // Simplified per the client brief: Services (dropdown), About, Projects &
  // Reviews, FAQ, Contact — plus a Get a Quote button rendered separately.
  //
  // Blog sits in the menu at the client's request. The brief listed it as a
  // supporting page rather than a nav item, but a blog nobody can find earns
  // nothing — no repeat visits and no internal links to the service pages.
  //
  // Promotions stays in the footer only.
  navigation: [
    { label: "Services", to: "/services", hasMega: true },
    { label: "About", to: "/about" },
    { label: "Projects & Reviews", to: "/projects" },
    { label: "Blog", to: "/blog" },
    { label: "FAQ", to: "/faqs" },
    { label: "Contact", to: "/contact" },
  ],
  footerLinks: {
    company: [
      { label: "About Us", to: "/about" },
      { label: "Our Services", to: "/services" },
      { label: "Projects & Reviews", to: "/projects" },
      { label: "Promotions", to: "/promotions" },
      { label: "Blog", to: "/blog" },
      { label: "FAQs", to: "/faqs" },
      { label: "Contact", to: "/contact" },
    ],
    legal: [
      { label: "Privacy Policy", to: "/privacy-policy" },
      { label: "Terms of Use", to: "/terms" },
    ],
  },
};

export const SEO = {
  "/": {
    metaTitle: "Emilio's Solutions — Professional Cleaning in Singapore",
    metaDescription:
      "Residential and commercial cleaning in Singapore. Post-renovation, end-of-tenancy, deep floor, sofa, mattress and more. 5,000+ jobs. 4.9-star Google rating. Book on WhatsApp.",
  },
  "/about": {
    metaTitle: "About Emilio's Solutions — Cleaning Done Right",
    metaDescription:
      "Singapore-based professional cleaning company. Experienced team, professional equipment and 5,000+ completed projects.",
  },
  "/why-us": {
    metaTitle: "Why Choose Emilio's Solutions",
    metaDescription:
      "4.9-star Google rating, public liability coverage, professional equipment, transparent quotations and 5,000+ completed jobs.",
  },
  "/services": {
    metaTitle: "Cleaning Services — Emilio's Solutions",
    metaDescription:
      "Post-renovation, end-of-tenancy, deep floor, formaldehyde removal, mattress, sofa, pressure washing, disinfection and defect inspection.",
  },
  "/contact": {
    metaTitle: "Contact Emilio's Solutions — Book on WhatsApp",
    metaDescription:
      "Send your property details on WhatsApp. Free quotation. Islandwide service in Singapore.",
  },
};
